<template>
    <div class="navbar hidden-xs hidden-md" v-if="!$root.mobile.isMobile">
        <div class="navbar-inner">
            <div class="left">
                <a v-on:click="$root.menu" class="link icon-only panel-open" data-panel="left">
                    <i class="las la-bars"></i>
                </a>
            </div>
            <div class="title sliding">Agenda Master</div>
            <div class="right">
                <a class="link icon-only panel-open" style="opacity: 0; pointer-events: none;">                    
                    <i class="las la-bars"></i>
                </a>
            </div>

            <div class="subnavbar">
                <div class="subnavbar-inner">
<!--                         <div class="segmented segmented-strong">
                        <button class="button button-active">Link 1</button>
                        <button class="button">Link 2</button>
                        <button class="button">Link 3</button>
                        <span class="segmented-highlight"></span>
                    </div> -->
                    <div class="tabbar">
                        <div class="toolbar-inner">
                            <a v-on:click="$root.go('Conta')" class="tab-link" v-bind:class="{'tab-link-active': $root.$route.name == 'Conta'}">
                                <i class="las la-user"></i>
                                Minha conta
                            </a>
<!--                             <a v-on:click="$root.go('Inicio')" class="tab-link ">
                                Início
                            </a> -->
                            <a v-on:click="$root.go('Pedidos')" class="tab-link" v-bind:class="{'tab-link-active': $root.$route.name == 'Pedidos'}">
                                <i class="las la-clock"></i>
                                Agendamentos
                            </a>
                            <a v-if="$root.user.tipo == 'prestador'" v-on:click="$root.go('Agendas')" class="tab-link" v-bind:class="{'tab-link-active': $root.$route.name == 'Agendas'}">
                                <i class="las la-cog"></i>
                                Opções de atendimento
                            </a>
                            <a v-if="$root.user.tipo == 'admin'" v-on:click="$root.go('Configuracoes')" class="tab-link" v-bind:class="{'tab-link-active': $root.$route.name == 'Configuracoes'}">
                                <i class="las la-cog"></i>
                                Configurações
                            </a>                            
                            <a v-on:click="$root.logout()" class="tab-link">
                                <i class="las la-sign-out-alt"></i>
                                Sair
                            </a>                                
                        </div>
                    </div>
                </div>
            </div>

        </div>


    </div>
</template>

<script>
export default {
    name: 'Top',
    data () {
        return {
            
        }
    },
    methods: {
             
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .subnavbar .tab-link.tab-link-active {
        background: #efefef;
        color: #333 !important;        
    }
</style>



// WEBPACK FOOTER //
// src/components/Top.vue